import * as ui from '@april9au/stack9-ui';

import IndustriesInfo from './IndustriesInfo';
import OccupationInfo from './OccupationInfo';

const S9PageSection = ui.S9PageSection.default;
const S9Row = ui.S9Row.default;
const S9Col = ui.S9Col.default;

type Props = {
  countrySetupId: number;
};
const ReferenceData = ({ countrySetupId }: Props) => (
  <S9PageSection title="" size="sm">
    <S9Row gutter={24}>
      <S9Col md={12}>
        <OccupationInfo
          countrySetupId={countrySetupId}
          initialValues={{ country_setup_id: countrySetupId }}
        />
      </S9Col>
      <S9Col md={12}>
        <IndustriesInfo
          countrySetupId={countrySetupId}
          initialValues={{ country_setup_id: countrySetupId }}
        />
      </S9Col>
    </S9Row>
  </S9PageSection>
);

export default ReferenceData;
